import CurrentPage                from "../../../../domain/fundamentals/pagination/CurrentPage";
import MailTemplate               from "../../../../domain/mail/template/MailTemplate";
import MailTemplateContent        from "../../../../domain/mail/template/MailTemplateContent";
import MailTemplateId             from "../../../../domain/mail/template/MailTemplateId";
import MailTemplateName           from "../../../../domain/mail/template/MailTemplateName";
import MailTemplateRepository     from "../../../../domain/mail/template/MailTemplateRepository";
import MailTemplates              from "../../../../domain/mail/template/MailTemplates";
import MailTemplateSubject        from "../../../../domain/mail/template/MailTemplateSubject";
import { ApiClient }              from "../../../configure/ApiClientConfig";
import {
  setMailTemplateAction,
  setMailTemplateContentAction,
  setMailTemplateNameAction,
  setMailTemplateSubjectAction
}                                 from "../../../redux/mail/template/MailTemplateAction";
import { setMailTemplatesAction } from "../../../redux/mail/template/MailTemplatesAction";

class MailTemplateDataSource implements MailTemplateRepository {
  constructor(private readonly dispatch) {
  }

  findByPage(currentPage: CurrentPage) {
    return ApiClient.get("/mail/templates", {
      params: {
        page: currentPage.value,
      }
    });
  }

  register(mailTemplate: MailTemplate) {
    return ApiClient.post("/mail/template", {
      name: mailTemplate.name.value,
      subject: mailTemplate.subject.value,
      content: mailTemplate.content.value,
    });
  }

  update(mailTemplate: MailTemplate) {
    return ApiClient.put("/mail/template", {
      id: mailTemplate.id.value,
      name: mailTemplate.name.value,
      subject: mailTemplate.subject.value,
      content: mailTemplate.content.value,
    });
  }

  delete(mailTemplateId: MailTemplateId) {
    return ApiClient.delete("/mail/template", {
      params: {
        id: mailTemplateId.value,
      }
    });
  }

  setMailTemplates(mailTemplates: MailTemplates) {
    this.dispatch(setMailTemplatesAction(mailTemplates));
  }

  setMailTemplate(mailTemplate: MailTemplate) {
    this.dispatch(setMailTemplateAction(mailTemplate));
  }

  setMailTemplateName(mailTemplateName: MailTemplateName) {
    this.dispatch(setMailTemplateNameAction(mailTemplateName));
  }

  setMailTemplateSubject(mailTemplateSubject: MailTemplateSubject) {
    this.dispatch(setMailTemplateSubjectAction(mailTemplateSubject));
  }

  setMailTemplateContent(mailTemplateContent: MailTemplateContent) {
    this.dispatch(setMailTemplateContentAction(mailTemplateContent));
  }
}

export default MailTemplateDataSource;
